import * as Auth from "./auth.reducer";
import * as Home from "./home.reducer";
import * as CurrentUser from "./currentuser.reducer";
import * as Contents from "./contents.reducer";
import * as Dictionaries from "./dictionaries.reducer";
import * as Alert from "./alertDialog.reducer";
import * as Deployment from "./deployments.reducer";
import * as Configuration from "./configuration.reducer";
import * as Styles from "./styles.reducer";
import * as SuperAdmin from "./superAdmin.reducer";
import * as Monitor from "./monitor.reducer";
import * as Administration from "./administration.reducer";
import * as UploadManager from "./uploadManager.reducer";
import * as DataSources from "./datasources.reducer";
import * as Communication from "./communication.reducer";

export const reducers = {
    currentuser: CurrentUser.reducer,

    contents: Contents.reducer,
    dictionaries: Dictionaries.reducer,
    deployment: Deployment.reducer,
    home: Home.reducer,
    alertDialog: Alert.reducer,
    configuration: Configuration.reducer,
    styles: Styles.reducer,
    superAdmin: SuperAdmin.reducer,
    monitoring: Monitor.reducer,
    administration: Administration.reducer,
    uploadManager: UploadManager.reducer,
    dataSources: DataSources.reducer,
    communication: Communication.reducer
};

